<dw-picker
  [isRange]="isRange"
  [value]="dwValue"
  (valueChange)="onValueChange($event)"
  [open]="dwOpen"
  [disabled]="dwDisabled"
  [format]="dwFormat"
  [allowClear]="dwAllowClear"
  [autoFocus]="dwAutoFocus"
  [className]="dwClassName"
  [placeholder]="dwPlaceHolder"
  [size]="dwSize"
  [style]="dwStyle"
  (openChange)="onOpenChange($event)"
>
  <date-range-popup *ngIf="realOpenState"
    [isRange]="isRange"
    [showWeek]="showWeek"
    [panelMode]="dwMode"
    (panelModeChange)="dwOnPanelChange.emit($event)"
    [value]="dwValue"
    (valueChange)="onValueChange($event)"
    [locale]="dwLocale?.lang"
    [showToday]="realShowToday"
    [showTime]="dwShowTime"
    [format]="dwFormat"
    [dateRender]="dwDateRender"
    [disabledDate]="dwDisabledDate"
    [disabledTime]="dwDisabledTime"
    [placeholder]="dwPlaceHolder"
    [dropdownClassName]="dwDropdownClassName"
    [popupStyle]="dwPopupStyle"
    [extraFooter]="extraFooter"
    [ranges]="dwRanges"
    (resultOk)="onResultOk()"
    (closePicker)="closeOverlay()"
  ></date-range-popup>
</dw-picker>